export default "__VITE_ASSET__eec85a2b__"